/** @jsx jsx */
import { type SerializedStyles, css, jsx } from '@emotion/react';

import type { ReactNode } from 'react';

import { Grid, Link, Typography2, breakpoints } from '@coursera/cds-core';

const styles = {
  root: css`
    gap: var(--cds-spacing-200);
    align-items: end;
    margin-bottom: var(--cds-spacing-150);

    ${breakpoints.down('xs')} {
      gap: 0;
    }
  `,
};

type Props = {
  showPageTitleHeadingSize?: boolean;
  additionalStyles?: SerializedStyles;
  ctaTitle?: string;
  ctaUrl?: string;
  onClickCta?: () => void;
  children: ReactNode;
  hideSecondaryCta?: boolean;
  dataTestId?: string;
};

const SectionHeadingComponent = (props: Props) => {
  const {
    children,
    additionalStyles,
    showPageTitleHeadingSize = false,
    ctaTitle,
    ctaUrl,
    onClickCta,
    hideSecondaryCta,
    dataTestId,
  } = props;

  return (
    <Grid container css={[styles.root, additionalStyles]}>
      <Grid item xs={12} sm="auto">
        <Typography2
          component={showPageTitleHeadingSize ? 'h1' : 'h2'}
          variant={showPageTitleHeadingSize ? 'titleMedium' : 'subtitleLarge'}
          data-testid={dataTestId}
        >
          {children}
        </Typography2>
      </Grid>
      {ctaTitle && ctaUrl && !hideSecondaryCta && (
        <Grid item xs={12} sm="auto">
          <Link variant="quiet" typographyVariant="subtitleMedium" href={ctaUrl} onClick={onClickCta}>
            {ctaTitle}
          </Link>
        </Grid>
      )}
    </Grid>
  );
};

export default SectionHeadingComponent;
